import interactiveMap from './interactive-map';
export default interactiveMap;
